var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _path2, _rect7, _rect8, _rect9, _path3, _circle, _path4, _path5, _circle2, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartiesCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.1305,
    y: 2.13054,
    width: 13.7389,
    height: 12.7389,
    rx: 3.78577,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1305,
    y: 2.13054,
    width: 13.7389,
    height: 12.7389,
    rx: 3.78577,
    stroke: "white",
    strokeWidth: 0.261087
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 6,
    width: 6,
    height: 5,
    rx: 2.0887,
    fill: "#F48D53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.25 7.5L46.5 8.25L47.5 8.75L46.75 9.5",
    stroke: "white",
    strokeWidth: 0.522175,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1305,
    y: 2.13054,
    width: 13.7389,
    height: 12.7389,
    rx: 3.78577,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1305,
    y: 2.13054,
    width: 13.7389,
    height: 12.7389,
    rx: 3.78577,
    stroke: "white",
    strokeWidth: 0.261087
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 6,
    width: 6,
    height: 5,
    rx: 2.08993,
    fill: "#C3F3E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8L30.7501 9L30 8.39993",
    stroke: "#40DA9E",
    strokeWidth: 0.499846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1305,
    y: 17.1305,
    width: 13.7389,
    height: 12.7389,
    rx: 3.78577,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40.1305,
    y: 17.1305,
    width: 13.7389,
    height: 12.7389,
    rx: 3.78577,
    stroke: "white",
    strokeWidth: 0.261087
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 21,
    width: 6,
    height: 5,
    rx: 2.08993,
    fill: "#C3F3E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23L46.7501 24L46 23.3999",
    stroke: "#40DA9E",
    strokeWidth: 0.499846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.4811,
    cy: 27.4068,
    r: 6.40685,
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.582 48.4992V46.6322C17.582 42.5935 20.8552 39.3203 24.8939 39.3203H32.2994C36.3381 39.3203 39.6113 42.5935 39.6113 46.6322V48.4992",
    fill: "#3158F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.582 48.4992V46.6322C17.582 42.5935 20.8552 39.3203 24.8939 39.3203H32.2994C36.3381 39.3203 39.6113 42.5935 39.6113 46.6322V48.4992H17.582Z",
    stroke: "#3158F2",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.58943,
    cy: 4.58943,
    r: 4.58943,
    transform: "matrix(-1 0 0 1 17.1719 24.3672)",
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3281 39.0547H12.3051C8.2664 39.0547 4.99322 42.3279 4.99322 46.3666V48.2335",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3281 39.0547H12.3051C8.2664 39.0547 4.99322 42.3279 4.99322 46.3666V48.2335H9.66067H11.5C11.5 48.2335 10.985 45.3036 11.5 43.501C12.5 40.001 14.3281 39.0547 14.3281 39.0547Z",
    stroke: "#3158F2",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 48.5L6 48L5 45.5L7.5 41L12 39.5L10.5 48.5Z",
    fill: "#3158F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartiesCheckLarge);
export default __webpack_public_path__ + "static/media/parties_check_large.cf5e5cf7e16a597fdc72b3140bf5441e.svg";
export { ForwardRef as ReactComponent };